import { Row, Col, Input, Button } from "antd";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

function UserSearchComponent({ searchUserData }) {
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [bloomAccountId, setBloomAccountId] = useState(null);
  const [tradelineNo, setTradelineNo] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [userId, setUserId] = useState(null);
  const [checkoutId, setCheckoutId] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const timeoutIdRef = useRef(null);
  const search = useLocation().search;

  useEffect(() => {
    const _phoneNumber = new URLSearchParams(search).get("phone");
    const _email = new URLSearchParams(search).get("email");
    const _firstName = new URLSearchParams(search).get("firstName");
    const _lastName = new URLSearchParams(search).get("lastName");
    const _userId = new URLSearchParams(search).get("userId");
    const _bloomAccountId = new URLSearchParams(search).get("bloomAccountId");
    const _tradelineNo = new URLSearchParams(search).get("tradelineNo");
    const _checkoutId = new URLSearchParams(search).get("checkoutId");
    const _dateOfBirth = new URLSearchParams(search).get("dateOfBirth");

    setPhone(_phoneNumber);
    setEmail(_email);
    setFirstName(_firstName);
    setLastName(_lastName);
    setUserId(_userId);
    setBloomAccountId(_bloomAccountId);
    setTradelineNo(_tradelineNo);
    setCheckoutId(_checkoutId);
    setDateOfBirth(_dateOfBirth);

    timeoutIdRef.current = setTimeout(() => {
      searchUserData(
        _phoneNumber,
        _email,
        _firstName,
        _lastName,
        _userId,
        _bloomAccountId,
        _tradelineNo,
        _checkoutId,
        _dateOfBirth
      );
    }, 1500);

    return () => clearTimeout(timeoutIdRef.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchUsers = () => {
    clearTimeout(timeoutIdRef.current);
    setUrlParams();
    searchUserData(phone, email, firstName, lastName, userId, bloomAccountId, tradelineNo, checkoutId, dateOfBirth);
  };

  const setUrlParams = () => {
    try {
      const searchParams = new URLSearchParams();
      if (phone) searchParams.set("phone", phone);
      if (email) searchParams.set("email", email);
      if (firstName) searchParams.set("firstName", firstName);
      if (lastName) searchParams.set("lastName", lastName);
      if (userId) searchParams.set("userId", userId);
      if (bloomAccountId) searchParams.set("bloomAccountId", bloomAccountId);
      if (tradelineNo) searchParams.set("tradelineNo", tradelineNo);
      if (checkoutId) searchParams.set("checkoutId", checkoutId);
      if (dateOfBirth) searchParams.set("dateOfBirth", dateOfBirth);

      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '');
      window.history.pushState({ path: newUrl }, '', newUrl);
    } catch (e) {
      console.log("Unable to set url params", e);
    }
  };

  const resetState = () => {
    setPhone(null);
    setEmail(null);
    setFirstName(null);
    setLastName(null);
    setUserId(null);
    setBloomAccountId(null);
    setTradelineNo(null);
    setCheckoutId(null);
    setDateOfBirth(null);
  };

  const resetSearch = () => {
    try {
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.pushState({ path: newUrl }, '', newUrl);
    } catch (e) {
      console.log("Unable to reset url params", e);
    }
    resetState();
    searchUserData();
  };
  const key = (event) => {
    if (event.key === "Enter") {
      searchUsers();
    }
  };

  return (
    <>
      {/* email/phone number/ first name/ last name / UserId. */}
      <Row className="search-box-container">
        <Col xs={24} xl={24} sm={24} md={24}>
          <Row gutter={[16, 20]} className={"search-row-container"}>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="First Name"
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
                onKeyUp={key}
              />
            </Col>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="Last Name"
                onChange={(e) => setLastName(e.target.value)}
                onKeyUp={key}
                value={lastName}
              />
            </Col>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                onKeyUp={key}
              />
            </Col>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="Phone Number"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
                onKeyUp={key}
              />
            </Col>
          </Row>
          <Row gutter={[16, 20]} className={"search-row-container"}>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="User ID"
                onChange={(e) => setUserId(e.target.value)}
                value={userId}
                onKeyUp={key}
              />
            </Col>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="Checkout ID"
                onChange={(e) => setCheckoutId(e.target.value)}
                value={checkoutId}
                onKeyUp={key}
              />
            </Col>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                className="header-search"
                placeholder="Bloom Account Id"
                onChange={(e) => setBloomAccountId(e.target.value)}
                value={bloomAccountId}
                onKeyUp={key}
              />
            </Col>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Input
                  className="header-search"
                  placeholder="Tradeline Number"
                  onChange={(e) => setTradelineNo(e.target.value)}
                  value={tradelineNo}
                  onKeyUp={key}
              />
            </Col>

          </Row>
          <Row gutter={[16, 20]} className={"search-row-container"}>
            <Col xs={12} xl={4} sm={6} md={4}>
              <label htmlFor="dateOfBirth" style={{ display: "block", marginBottom: 4 }}>
                Date of Birth
              </label>
              <Input
                  id="dateOfBirth"
                  className="header-search"
                  placeholder="Date of Birth"
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  value={dateOfBirth}
                  onKeyUp={key}
                  type="date"
              />
            </Col>

          </Row>
          <Row style={{ justifyContent: "flex-end", alignItems: "center" }}>
            <Col xs={12} xl={4} sm={6} md={4}>
              <Row gutter={[16, 20]}>
                <Col span={12}>
                  <Button block type="primary" onClick={searchUsers}>
                    Search
                  </Button>
                </Col>
                <Col span={12}>
                  <Button block type="seccandry" onClick={resetSearch}>
                    Reset
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default UserSearchComponent;
